export default "__VITE_ASSET__DjsnCASN__"